export default __webpack_public_path__ + "static/faq4-bd4ea9dad0b9316c1ade36c38854c3e3.png";